// Pure helpers for the SBOM page: what is flawed, the licence and makeup bars, and the search.
export const LICENSE = {
  permissive: { label: 'Permissive (MIT, Apache)', color: '#22c55e' },
  copyleft: { label: 'Copyleft (GPL)', color: '#f59e0b' },
  restricted: { label: 'Commercial or restricted', color: '#ef4444' },
  unknown: { label: 'Unknown', color: '#64748b' }
};
export const ECO = { npm: 'npm', pip: 'pip', maven: 'Maven', system: 'System', other: 'Other' };

export const flawed = (rows) => rows.filter((r) => (r.vulns || 0) > 0).sort((a, b) => b.vulns - a.vulns || a.name.localeCompare(b.name));
export const clean = (rows) => rows.filter((r) => !(r.vulns || 0));

export function summary(rows) {
  const bad = flawed(rows);
  return {
    total: rows.length,
    flawedCount: bad.length,
    cves: new Set(bad.flatMap((r) => r.cve_ids || [])).size,
    review: rows.filter((r) => r.licenseRisk === 'copyleft' || r.licenseRisk === 'restricted' || r.licenseRisk === 'unknown').length,
    ecosystems: new Set(rows.map((r) => r.ecosystem)).size,
    lastChecked: rows.map((r) => r.last_matched_at).filter(Boolean).sort().pop() || null
  };
}

const tally = (rows, key) => rows.reduce((m, r) => ({ ...m, [r[key] || 'unknown']: (m[r[key] || 'unknown'] || 0) + 1 }), {});
export const licenseBars = (rows) => Object.entries(tally(rows, 'licenseRisk')).map(([k, n]) => ({ id: k, label: (LICENSE[k] || LICENSE.unknown).label, color: (LICENSE[k] || LICENSE.unknown).color, n })).sort((a, b) => b.n - a.n);
export const ecoBars = (rows) => Object.entries(tally(rows, 'ecosystem')).map(([k, n]) => ({ id: k, label: ECO[k] || k, n })).sort((a, b) => b.n - a.n);

export const search = (rows, q) => {
  const needle = String(q || '').trim().toLowerCase();
  return needle ? rows.filter((r) => `${r.name} ${r.version} ${r.license} ${(r.cve_ids || []).join(' ')}`.toLowerCase().includes(needle)) : rows;
};
export const pct = (n, total) => (total ? Math.round((n / total) * 100) : 0);
